import React from 'react';
import {StyleSheet, Pressable} from 'react-native';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {RootNavigatorParams, Routes} from 'navigation/Routes';
import {Suggestions} from 'redux/slices/dashboardSlice';
import {spacing} from 'theme/Units';
import {Icon, Text} from 'ui-kits';
import colors from 'theme/Colors';
import {splitStringByWord} from 'utils/splitStringByWords';
import {useDispatch} from 'react-redux';import {
  setCurrentSelectedProject,
  setProjectName,
} from 'redux/slices/projectSlice';
import {setCurrentSelectedEmployee} from 'redux/slices/employeeSlice';
import {setCurrentSelectedStory} from 'redux/slices/userStorySlice';

type SuggestionsPropType = Readonly<
  {
    navigation: NativeStackScreenProps<RootNavigatorParams>['navigation'];
    searchText: string;
  } & Suggestions
>;

export function Suggestion(props: SuggestionsPropType) {
  const {category, id, metadata, name, navigation, searchText} = props;
  const dispatch = useDispatch();
  const {after, before, match} = splitStringByWord(name, searchText, false);

  function gotoProjectDashboard(projectID: number, projectName: string) {
    dispatch(setCurrentSelectedProject(projectID));
    dispatch(setProjectName(projectName));

    navigation.navigate(Routes.PROJECT, {
      screen: Routes.PROJECTDASHBOARD,
      params: {id: projectID?.toString()},
    } as any);
  }

  function gotoEmployeeDetails(employeeID: number) {
    dispatch(setCurrentSelectedEmployee(employeeID));

    navigation.navigate(Routes.TEAM, {
      screen: Routes.VIEW_EMPLOYEE_DETAILS,
      params: {id: employeeID?.toString()},
    } as any);
  }

  function gotoUserStoryDetails(userStoryID: number, projectID: number, projectName: string) {
    dispatch(setCurrentSelectedStory(userStoryID));
    dispatch(setProjectName(projectName));

    navigation.navigate(Routes.PROJECT, {
      screen: Routes.PROJECTDASHBOARD,
      params: {
        screen: Routes.PROJECT_MANAGEMENT,
        params: {
          screen: Routes.VIEW_USER_STORY,
          params: {
            id: projectID?.toString(),
            usid: userStoryID?.toString(),
          },
        },
      },
    } as any);
  }

  function handleNavigate() {
    switch (category) {
      case 'employee':
        gotoEmployeeDetails(id);
        break;
      case 'project':
        gotoProjectDashboard(id, name);
        break;
      case 'user_story':
        gotoUserStoryDetails(id, metadata.proj_id, metadata.name);
        break;
    }
  }

  function formatedID() {
    // this variable will have id with prefilled '0's upto 3 digits
    // for example 1 -> 001, 21 -> 021, 452 -> 452
    const zeroPaddedID = id?.toString().padStart(3, '0');

    switch (category) {
      case 'employee':
        return `EMP-${zeroPaddedID}`;
      case 'project':
        return `PROJ-${zeroPaddedID}`;
      case 'user_story':
        return `US-${zeroPaddedID}`;
    }
  }

  return (
    <Pressable onPress={handleNavigate} style={styles.container}>
      <Icon type="search" size={14} />
      <Text style={styles.text}>
        <Text style={styles.idWrapper}>{formatedID()}</Text>
        {before}
        <Text style={styles.matchingText}>{match}</Text>
        {after}
      </Text>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingVertical: spacing['1'],
    paddingHorizontal: spacing['3'],
    flexDirection: 'row',
    alignItems: 'center',
  },
  idWrapper:{
    minWidth: 80,
    display:'inline-flex',
  },
  matchingText: {
    color: colors.palette.black,
  },
  text: {
    marginLeft: spacing['6'],
    fontSize: 16,
    fontWeight: 500,
    color: colors.palette.brandDarkGray,
  },
});
